module.exports = __webpack_public_path__ + "static/img/4016.87dfa4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/4016.png
// module id = 723
// module chunks = 0 1 12